import Component from './RichLayout.component';

export default Component;
